import "./style.css"
import React from 'react'
export const NoAccess = () => {
  return (
    <div className="aliyun-preview-container-noaccess">
      <img src="/image/noaccess.png" alt="" />
    </div>
  )
}